// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:08:14
import { Guid, GuidTools } from '@models/guid';
import { BaseObject } from '@models/BaseObject';

export abstract class ProcedureEditorInterface_abstract extends BaseObject {
  static $t: string = 'SagaActionLib.ProcedureEditorInterface';
  $t: string = 'SagaActionLib.ProcedureEditorInterface';

  public static GetMembers(): string[] {
    return ['Editor', 'BaseProfile', 'EditProfile'];
  }

  public GetMembers(): string[] {
    return ProcedureEditorInterface_abstract.GetMembers();
  }

  public _init(): void {
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/
    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public Editor: string;
  public BaseProfile: string;
  public EditProfile: string;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
